"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var useStepIconStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    root: {
      width: 20,
      height: 20,
      borderRadius: '50%',
      backgroundColor: palette.common.white
    },
    active: {
      backgroundColor: palette.secondary.main
    },
    completed: {
      backgroundColor: palette.secondary.main
    },
    clickable: {
      cursor: 'pointer'
    }
  };
});

var StepIcon = function StepIcon(_ref2) {
  var active = _ref2.active,
      completed = _ref2.completed,
      onClick = _ref2.onClick;
  var classes = useStepIconStyles();
  var isClickable = onClick && completed && !active;

  var handleOnClick = function handleOnClick() {
    isClickable && onClick && onClick();
  };

  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    component: "span",
    className: (0, _classnames.default)(classes.root, {
      [classes.active]: active,
      [classes.completed]: completed,
      [classes.clickable]: isClickable
    }),
    onClick: handleOnClick
  });
};

var _default = StepIcon;
exports.default = _default;